<template>
  <div class="icon-mobile-apps">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(9 9)"
        stroke="none"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
      >
        <!-- eslint-disable max-len -->
        <path
          class="icon-mobile-apps__path icon-mobile-apps__path__path-1"
          d="M42.3105,-0.0002 C18.9435,-0.0002 -0.0005,18.9428 -0.0005,42.3098 C-0.0005,65.6768 18.9435,84.6198 42.3105,84.6198 C65.6775,84.6198 84.6205,65.6768 84.6205,42.3098 C84.6205,18.9428 65.6775,-0.0002 42.3105,-0.0002"
          stroke="#FFFFFF"
        />
        <g
          transform="translate(26.000000, 17.000000)"
          stroke="#FFFFFF"
          stroke-width="2"
        >
          <path
            class="icon-mobile-apps__path icon-mobile-apps__path__path-3"
            d="M30,4.09101369 L30,2.74447304 C30,1.22879984 28.7985,-5.68434189e-14 27.316875,-5.68434189e-14 L2.683125,-5.68434189e-14 C1.2015,-5.68434189e-14 -1.42108547e-14,1.22879984 -1.42108547e-14,2.74447304 L-1.42108547e-14,11.7614247 L-1.20792265e-13,40.0649414 L30,40.0649414 L30,4.09101369 Z"
          />
          <path
            class="icon-mobile-apps__path icon-mobile-apps__path__path-2"
            d="M0,40 L0,41.6457298 C0,43.4981719 1.2015,45 2.683125,45 L27.316875,45 C28.7985,45 30,43.4981719 30,41.6457298 L30,40 L0,40 Z"
          />
          <path
            class="icon-mobile-apps__path icon-mobile-apps__path__path-2"
            d="M21.125,11 L15.875,11 C15.3917803,11 15,10.6082197 15,10.125 L15,4.875 C15,4.39178026 15.3917803,4 15.875,4 L21.125,4 C21.6082197,4 22,4.39178026 22,4.875 L22,10.125 C22,10.6082197 21.6082197,11 21.125,11 Z M10.125,11 L4.875,11 C4.39178026,11 4,10.6082197 4,10.125 L4,4.875 C4,4.39178026 4.39178026,4 4.875,4 L10.125,4 C10.6082197,4 11,4.39178026 11,4.875 L11,10.125 C11,10.6082197 10.6082197,11 10.125,11 Z M10.125,22 L4.875,22 C4.39178026,22 4,21.6082197 4,21.125 L4,15.875 C4,15.3917803 4.39178026,15 4.875,15 L10.125,15 C10.6082197,15 11,15.3917803 11,15.875 L11,21.125 C11,21.6082197 10.6082197,22 10.125,22 Z"
          />
        </g>
        <!-- eslint-enable max-len -->
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconMobileApps'
};
</script>

<style lang="scss" src="@/assets/icons/icon-mobile-apps-view.scss"></style>



// WEBPACK FOOTER //
// icon-mobile-apps-view.vue